// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-stepper[data-v-c2addcbe]{background:transparent}.object-placeholder[data-v-c2addcbe]{border:2px dashed #000;padding:10px}", ""]);
// Exports
module.exports = exports;
